// 实时电平外部 store:asr 每帧(~15/s)push 最新电平(0..1),SoundWave 用 useSyncExternalStore 订阅。
// 刻意不走 xstate——高频事件若进状态机会触发整页重渲染;这里只有订阅的 SoundWave 自己重渲。
const SIZE = 20
let bars: number[] = new Array(SIZE).fill(0)
const listeners = new Set<() => void>()

export const audioLevel = {
    push(v: number) {
        const x = v < 0 ? 0 : v > 1 ? 1 : v
        bars = [...bars.slice(1), x] // 新数组 → getBars 快照变化 → 触发订阅者重渲(滚动波形)
        for (const l of listeners) l()
    },
    getBars(): number[] {
        return bars
    },
    subscribe(l: () => void): () => void {
        listeners.add(l)
        return () => listeners.delete(l)
    }
}
